if (!customElements.get('product-subscriptions')) {
  class productSubscriptions extends HTMLElement {
    constructor() {
      super()

      this.form = this.closest('form')
      this.sellingPlanInput = this.querySelector('[data-selling-plan-input]')
      this.variantSellingPlanGroupings = this.querySelectorAll('[data-selling-plan-variant-grouping]')
      this.variantIdInput = this.form.querySelector('input[name="id"]')
      this.sellingPlanOptionWrappers = this.querySelectorAll('[data-selling-plan-wrapper]')
      this.oneTimeSellingPlanOption = this.querySelector('[data-selling-plan][data-radio-type="one_time_purchase"]')
      this.sellingPlanOptions = this.querySelectorAll('[data-selling-plan]')
      this.initialSellingPlanLabel = this.querySelector('[data-initial-selling-plan-label]')
      this.atcButton = this.form.querySelector('[data-buy-buttons-atc]')

      // One Time elements
      this.oneTimeVariantSelection = this.querySelector('[data-one-time-variant-selection]')
      this.oneTimeVariantSelector = this.querySelector('[data-one-time-variant-selector]')
      this.oneTimeVariantSelectorOptions = this.querySelectorAll('[data-one-time-variant-selector-option]')
      this.oneTimeVariantIndicators = this.querySelectorAll('[data-one-time-variant-indicator]')
      this.oneTimeSavingsIndicators = this.querySelectorAll('[data-one-time-savings-indicator]')
      this.oneTimePriceDisplay = this.querySelector('[data-one-time-price-display]')
    }

    connectedCallback () {
      if (this.atcButton) {
        this.atcButton.disabled = true;
      }

      this.sellingPlanOptions.forEach(sellingPlanOption => {
        sellingPlanOption.addEventListener('change', () => {
          this.toggleSellingPlans(sellingPlanOption)
        })
      })

      const shoppingParam = this.getShoppingParameter()
      const preselectedOption = Array.from(this.sellingPlanOptions).find((option) => option.checked)
      if (shoppingParam) {
        this.handleShoppingParameter(shoppingParam)
      } else if (preselectedOption) {
        this.toggleSellingPlans(preselectedOption)
      } else {
        this.handleDefaultSelection()
      }

      this.setListHeight()

      if (this.oneTimeVariantSelection) {
        this.setupOneTimeVariantSelection()
      }

      window.addEventListener('resize', () => this.setListHeight())
      window.addEventListener('load', () => this.removeRechargeWidget())

      window.addEventListener('DOMContentLoaded', () => {
        this.classList.add('js-ready');
      });
    }

    isMobileDevice() {
      return window.matchMedia('(max-width: 768px)').matches
    }

    getMobileDefaultVariant() {
      if (!this.isMobileDevice()) return null
      
      const mobileDefaultElement = this.querySelector('[data-mobile-default="true"]')
      return mobileDefaultElement ? mobileDefaultElement.dataset.oneTimeVariantIndicator : null
    }

    getShoppingParameter() {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get('shopping')
    }

    handleShoppingParameter(shoppingParam) {
      const isOneTime = shoppingParam.includes('otp')
      const bottleCount = shoppingParam.replace('otp', '')
      
      const targetVariant = this.findVariantByBottleCount(bottleCount)
      
      if (!targetVariant) {
        console.warn(`No variant found for bottle count: ${bottleCount}`)
        this.handleDefaultSelection()
        return
      }

      if (isOneTime) {
        this.selectOneTimePurchase(targetVariant.id)
      } else {
        this.selectSubscription(targetVariant.id)
      }
    }

    updateVariantIndicators(variantId) {
      this.oneTimeVariantIndicators.forEach((variantIndicator) => {
        variantIndicator.classList.toggle('active', variantIndicator.dataset.oneTimeVariantIndicator === variantId)
      })

      this.oneTimeSavingsIndicators.forEach((savingsIndicator) => {
        savingsIndicator.classList.toggle('active', savingsIndicator.dataset.oneTimeSavingsIndicator === variantId)
      })
    }

    findVariantByBottleCount(bottleCount) {
      const subscriptionInputs = this.querySelectorAll('[data-radio-type="selling_plan"][data-variant-id]')
      
      for (let input of subscriptionInputs) {
        const variantId = input.dataset.variantId
        const label = input.closest('[data-selling-plan-wrapper]').querySelector('.product-subscriptions__subscription-label')
        
        if (label) {
          const labelText = label.textContent.toLowerCase()
          if (bottleCount === '1' && (labelText.includes('monthly') || labelText.includes('1'))) {
            return { id: variantId }
          } else if (bottleCount === '3' && labelText.includes('3')) {
            return { id: variantId }
          } else if (bottleCount === '6' && labelText.includes('6')) {
            return { id: variantId }
          }
        }
      }
      
      for (let option of this.oneTimeVariantSelectorOptions) {
        const variantId = option.dataset.oneTimeVariantSelectorOption
        const labelText = option.getAttribute('aria-label') || option.textContent || ''
        
        if (bottleCount === '1' && labelText.includes('1 Bottle')) {
          return { id: variantId }
        } else if (bottleCount === '3' && labelText.includes('3 Bottles')) {
          return { id: variantId }
        } else if (bottleCount === '6' && labelText.includes('6 Bottles')) {
          return { id: variantId }
        }
      }
      
      return null
    }

    selectSubscription(variantId) {
      const targetInput = this.querySelector(`[data-radio-type="selling_plan"][data-variant-id="${variantId}"]`)
      
      if (targetInput) {
        targetInput.checked = true
        const changeEvent = new Event('change')
        targetInput.dispatchEvent(changeEvent)
      } else {
        console.warn(`No selling plan input found for variant ID: ${variantId}`)
        this.handleDefaultSelection()
      }
    }

    selectOneTimePurchase(variantId) {
      if (this.oneTimeSellingPlanOption) {
        this.oneTimeSellingPlanOption.checked = true
        this.oneTimeSellingPlanOption.dispatchEvent(new Event('change'))
      }
      
      const targetOption = this.querySelector(`[data-one-time-variant-selector-option="${variantId}"]`)
      if (targetOption) {
        targetOption.checked = true
        const changeEvent = new Event('change')
        targetOption.dispatchEvent(changeEvent)
        
        this.updateVariantIndicators(variantId)
        
        this.variantIdInput.value = variantId
        this.changeOneTimePriceDisplay(true)
      } else {
        this.variantIdInput.value = variantId
      }
    }

    handleDefaultSelection() {
      const mobileDefaultVariantId = this.getMobileDefaultVariant()
      
      if (mobileDefaultVariantId) {
        this.updateMobileDefaultDisplay(mobileDefaultVariantId)
      }
      
      let targetLabel = this.initialSellingPlanLabel
      if (!targetLabel) {
        const firstWrapper = this.sellingPlanOptionWrappers[0]
        targetLabel = firstWrapper ? firstWrapper.querySelector('label') : null
      }
      
      if (targetLabel) {
        const inputId = targetLabel.getAttribute('for')
        let targetInput = null
        if (inputId) {
          targetInput = this.querySelector(`#${CSS.escape(inputId)}`)
        }
        if (!targetInput) {
          targetInput = targetLabel.closest('[data-selling-plan-wrapper]')?.querySelector('[data-selling-plan]')
        }        
        if (targetInput) {
          targetInput.checked = true
          targetInput.dispatchEvent(new Event('change'))
        }
      }
    }

    updateMobileDefaultDisplay(variantId) {
      this.updateVariantIndicators(variantId)
      
      this.variantIdInput.value = variantId
      this.changeOneTimePriceDisplay(false)
    }

    removeRechargeWidget() {
      let interval = setInterval(() => {
        const rechargeWidget = document.querySelector('.rc-container-wrapper')

        if(rechargeWidget) {
          rechargeWidget.remove()
          clearInterval(interval)
        }
      }, 2000)
    }

    toggleSellingPlans(sellingPlanOption) {
      this.sellingPlanInput.value = sellingPlanOption.value
      this.sellingPlanInput.name = sellingPlanOption.value ? 'selling_plan' : ''

      if (this.oneTimeVariantSelection && !sellingPlanOption.value) {
        const selectedOneTimeVariant = this.querySelector('[data-one-time-variant-indicator].active')
        this.variantIdInput.value = selectedOneTimeVariant.dataset.oneTimeVariantIndicator
        this.changeOneTimePriceDisplay(true)
      } else {
        this.variantIdInput.value = sellingPlanOption.dataset.variantId
        this.setBuyButtonPrice(sellingPlanOption)
      }

      this.sellingPlanOptionWrappers.forEach(sellingPlanOptionWrapper => {
        sellingPlanOptionWrapper.classList.toggle('active', sellingPlanOptionWrapper.contains(sellingPlanOption))
      })

      if (this.atcButton) {
        this.atcButton.disabled = false
      }
    }

    setBuyButtonPrice(sellingPlanOption) {
      const parentWrapper = sellingPlanOption.closest('product-rerender')
      const buyButtonPrice = parentWrapper?.querySelector('[data-buy-button-price]')
      const percentageOffNewVariantPrice = sellingPlanOption.getAttribute('data-percentage-off-newvariantprice');


      if (buyButtonPrice) {
        buyButtonPrice.innerHTML = `${percentageOffNewVariantPrice }  &ndash; `
      }
    }

    setListHeight() {
      this.sellingPlanOptionWrappers.forEach(sellingPlanOptionWrapper => {
        const list = sellingPlanOptionWrapper.querySelector('[data-selling-plan-details]')
        if (!list) { return }
        list.style.setProperty('--list-height', `${list.scrollHeight}px`)
      })
    }

    variantChanged (variantId) {
      this.variantSellingPlanGroupings.forEach(variantSellingPlanGrouping => {
        variantSellingPlanGrouping.classList.toggle('hidden', variantId !== Number(variantSellingPlanGrouping.dataset.variantId))
        if (variantSellingPlanGrouping.classList.contains('hidden')) { return }

        const options = variantSellingPlanGrouping.querySelectorAll('[data-selling-plan-option]')
        options[0].checked = true
        const changeEvent = new Event('change')
        options[0].dispatchEvent(changeEvent)
      })
    }

    setupOneTimeVariantSelection() {
      this.oneTimeVariantSelectorOptions.forEach((selectorOption) => {
        selectorOption.addEventListener('change', () => {
          this.changeOneTimeVariant(selectorOption.dataset.oneTimeVariantSelectorOption)
        })
      })
    }

    changeOneTimeVariant(variantId) {
      this.updateVariantIndicators(variantId)

      this.oneTimeSellingPlanOption.checked = true
      this.oneTimeSellingPlanOption.dispatchEvent(new Event('change'))

      this.oneTimeVariantSelector.click()

      if (this.oneTimeVariantSelection.closest('[data-selling-plan-wrapper]').classList.contains('active')) {
        this.variantIdInput.value = variantId
        this.changeOneTimePriceDisplay(true)
      } else {
        this.changeOneTimePriceDisplay(false)
      }
    }

  changeOneTimePriceDisplay(changeBuyButton) {
  const parentWrapper = this.oneTimeVariantSelection.closest('product-rerender');
  const buyButtonPrice = parentWrapper?.querySelector('[data-buy-button-price]');
  const selectedOneTimeVariant = this.querySelector('[data-one-time-variant-indicator].active');
  const percentageOff = selectedOneTimeVariant.dataset.percentageOff;

  if (!selectedOneTimeVariant) return;

  const variantPrice = selectedOneTimeVariant.dataset.oneTimeVariantPrice;

  const finalVariantPrice =
    selectedOneTimeVariant.dataset.oneTimeFinalPrice ||
    selectedOneTimeVariant.dataset.oneTimeExtraPrice ||
    selectedOneTimeVariant.dataset.oneTimeVariantDiscountedPrice ||
    variantPrice;

  const discountedVariantPrice = selectedOneTimeVariant.dataset.oneTimeVariantDiscountedPrice || '';

  const isOneBottle =
    selectedOneTimeVariant?.hasAttribute('data-one-bottle') &&
    String(selectedOneTimeVariant.dataset.oneBottle || '').toLowerCase() !== 'false';

  if (changeBuyButton && buyButtonPrice) {
    buyButtonPrice.innerHTML = `${finalVariantPrice} &ndash; `;
  }

  if (finalVariantPrice === variantPrice) {
    this.oneTimePriceDisplay.innerHTML = `<strong>${variantPrice}</strong>`;
    return;
  }


  const middle =
    (percentageOff > 0 && !isOneBottle && discountedVariantPrice && discountedVariantPrice !== variantPrice)
     ? `<s class="text-subdued"><strong>${discountedVariantPrice}</strong></s><br>`
    : (discountedVariantPrice && discountedVariantPrice !== variantPrice)
      ? `<strong>${discountedVariantPrice}</strong>`
      : '';
       

  this.oneTimePriceDisplay.innerHTML = `
  ${percentageOff > 0 ? `<strong class="finalvariantprice">${finalVariantPrice}</strong><br>` : ''}
   <strong class="discounted-container"> ${middle}
    <s class="text-subdued float-none">${variantPrice}</s> </strong>
  `;
}

  }

  window.customElements.define('product-subscriptions', productSubscriptions)


  
}

